export const ECOSYSTEM_CORRIDOR_HEAD_CONTACT_EMAIL = "team@gtsetu.com";

export const ECOSYSTEM_CORRIDOR_HEAD_MAILTO = `mailto:${ECOSYSTEM_CORRIDOR_HEAD_CONTACT_EMAIL}?subject=${encodeURIComponent("Ecosystem Corridor Head Inquiry")}`;

export type EcosystemCorridorHeadDetailSection = {
  title: string;
  body: string;
};

export const ECOSYSTEM_CORRIDOR_HEAD_DETAIL_SECTIONS: EcosystemCorridorHeadDetailSection[] = [
  {
    title: "HOW IT WORKS",
    body: "Whether you represent a sector, a business network or possess specialized expertise, companies can engage with your ecosystem to explore global partnerships, market-entry opportunities, distribution channels, technology collaborations, sourcing relationships and strategic business connections.",
  },
  {
    title: "HOW YOU EARN",
    body: "Generate opportunities through your expertise and ecosystem.",
  },
  {
    title: "REQUIREMENTS",
    body: "We look for experienced professionals, consultants, industry leaders, associations, chambers and ecosystem builders with established sector knowledge and business networks.",
  },
];

export type CorridorListEntry<T> =
  | { type: "item"; item: T; key: string }
  | { type: "promo"; key: string };

const PROMO_AFTER_EVERY_TWO_THRESHOLD = 4;

function interleavePromoEveryTwo<T>(
  items: T[],
  itemKey: (item: T) => string,
): CorridorListEntry<T>[] {
  const result: CorridorListEntry<T>[] = [];

  items.forEach((item, index) => {
    result.push({ type: "item", item, key: itemKey(item) });
    if ((index + 1) % 2 === 0) {
      result.push({ type: "promo", key: `promo-after-${index}` });
    }
  });

  return result;
}


export function buildEcosystemCorridorEntries<T>(
  realItems: T[],
  placeholderItems: T[],
  itemKey: (item: T) => string,
): CorridorListEntry<T>[] {
  if (realItems.length === 0) {
    const result: CorridorListEntry<T>[] = [{ type: "promo", key: "promo" }];
    for (const item of placeholderItems) {
      result.push({ type: "item", item, key: itemKey(item) });
    }
    return result;
  }

  const allItems = [...realItems, ...placeholderItems];

  if (allItems.length >= PROMO_AFTER_EVERY_TWO_THRESHOLD) {
    return interleavePromoEveryTwo(allItems, itemKey);
  }

  const result: CorridorListEntry<T>[] = [];

  for (const item of realItems) {
    result.push({ type: "item", item, key: itemKey(item) });
  }
  result.push({ type: "promo", key: "promo" });
  for (const item of placeholderItems) {
    result.push({ type: "item", item, key: itemKey(item) });
  }

  return result;
}
